import React, { createContext, useState } from "react";

const ReportAccountantContext = createContext();

const optionsMounth = [
  { id: 1, descricao: "Janeiro" },
  { id: 2, descricao: "Fevereiro" },
  { id: 3, descricao: "Março" },
  { id: 4, descricao: "Abril" },
  { id: 5, descricao: "Maio" },
  { id: 6, descricao: "Junho" },
  { id: 7, descricao: "Julho" },
  { id: 8, descricao: "Agosto" },
  { id: 9, descricao: "Setembro" },
  { id: 10, descricao: "Outubro" },
  { id: 11, descricao: "Novembro" },
  { id: 12, descricao: "Dezembro" },
];

const newDate = new Date();

const ReportAccountantContextProvider = ({ children }) => {
  const [cnpj, setCnpj] = useState("");
  const [reason, setReason] = useState("");
  const [status, setStatus] = useState(null);
  const [base, setBase] = useState("");
  const [accountant, setAccountant] = useState(null);
  const [year, setYear] = useState({
    descricao: newDate.getFullYear().toString(),
  });
  const [mounth, setMounth] = useState(
    optionsMounth.find(i => i.id === newDate.getMonth() + 1)
  );
  const [valuesTable, setValuesTable] = useState([]);
  const [optionsStatus, setOptionsStatus] = useState([]);
  const [optionsAccountants, setOptionsAccountants] = useState([]);
  const [selectionClients, setSelectionClients] = useState([]);

  return (
    <ReportAccountantContext.Provider
      value={{
        valuesTable,
        setValuesTable,
        cnpj,
        setCnpj,
        reason,
        setReason,
        status,
        setStatus,
        base,
        setBase,
        accountant,
        setAccountant,
        year,
        setYear,
        mounth,
        setMounth,
        optionsStatus,
        setOptionsStatus,
        optionsAccountants,
        setOptionsAccountants,
        selectionClients,
        setSelectionClients,
      }}
    >
      {children}
    </ReportAccountantContext.Provider>
  );
};

export { ReportAccountantContextProvider, ReportAccountantContext };
